// extracted by mini-css-extract-plugin
module.exports = {"mainD":"portfolio_mainD__2znhs","card":"portfolio_card__3WaB4"};